import React, { useRef } from 'react';
import SwiperCore, { A11y, Keyboard, Navigation, Pagination, FreeMode } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import useSwiperColGap from '@stone/hooks/useSwiperColGap';
import GallerySlide from './GallerySlide';
import classNames from 'classnames';
import CarouselNavigation from '@stone/ui/button/CarouselNavigation';
SwiperCore.use([Keyboard, Navigation, A11y, Pagination, FreeMode]);
const GallerySimple = (props) => {
    const { slides, mediaQueries } = props;
    const { isDesktop } = mediaQueries;
    const swiperRef = useRef(null);
    const gap = useSwiperColGap(swiperRef, 2, props.isIndented ? 20 : 24);
    const renderNavigation = () => (React.createElement("div", { className: "gallery__carousel-pagination--simple" },
        React.createElement(CarouselNavigation, { id: `gallery-${props.id}`, right: true })));
    const renderCarousel = () => {
        var _a;
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: classNames('col-24', { 'col-lg-20 offset-lg-2': props.isIndented }) },
                React.createElement("div", { className: "gallery__carousel gallery__carousel--simple" }, !!(slides === null || slides === void 0 ? void 0 : slides.length) && (React.createElement(Swiper, { onSwiper: (swiper) => (swiperRef.current = swiper), spaceBetween: isDesktop ? gap : 12, slidesPerView: "auto", watchSlidesProgress: true, className: (_a = props.alignement) === null || _a === void 0 ? void 0 : _a.toLowerCase(), freeMode: true, navigation: {
                        nextEl: `.gallery-${props.id}-navigation--next`,
                        prevEl: `.gallery-${props.id}-navigation--prev`,
                    } }, props.slides.map((slide) => (React.createElement(SwiperSlide, { className: "gallery__carousel-slide", key: slide.id }, ({ isVisible }) => React.createElement(GallerySlide, { slide: slide, isVisible: isVisible, ratio: props.ratio, isDesktop: props.mediaQueries.isDesktop }))))))))));
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "container" },
            React.createElement("div", { className: "row" }, renderNavigation()),
            React.createElement("div", { className: "row" }, renderCarousel()))));
};
export default GallerySimple;
